

import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { HelmetProvider }   from 'react-helmet-async';

import Header              from './components/Header';
import Footer              from './components/Footer';
import SEO                 from './components/SEO';
import seoPages            from './seoConfig';

import Home                from './pages/Home';
import About               from './pages/About';
import Businesses          from './pages/Businesses';
import Investors           from './pages/Investors';
import Newsroom            from './pages/Newsroom';
import Careers             from './pages/Careers';
import Contact             from './pages/Contact';
import Founder             from './pages/Founder';
import IndustriesTechCons  from './pages/IndustriesTechCons';
import IndustriesBuilders  from './pages/IndustriesBuilders';
import IndustriesMedia     from './pages/IndustriesMedia';
import IndustriesLuxury    from './pages/IndustriesLuxury';
import IndustriesSocial    from './pages/IndustriesSocial';
import Aalitech            from './pages/Aalitech';
import AaliConssultancy    from './pages/AaliConssultancy';
import AaliBuilders        from './pages/AaliBuilders';
import AaliMovies          from './pages/AaliMovies';
import AaliFilmz           from './pages/AaliFilmz';
import AaliMusic           from './pages/AaliMusic';
import AaliGoldJewelz      from './pages/AaliGoldJewelz';
import AaliTrustz          from './pages/AaliTrustz';
import GlobalLocations     from './pages/GlobalLocations';
import ComingSoon          from './pages/ComingSoon';
import NotFound            from './pages/NotFound';
import ChatPanel           from './components/ChatPanel';

// ── Scroll to top on every navigation ─────────────────────────────────────

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// ── Automatic per-route SEO from central config ────────────────────────────

function SEOManager() {
  const { pathname } = useLocation();

  // Exact match first, then fallback for unknown routes (404 etc.)
  const config = seoPages[pathname] ?? {
    title:       'Page Not Found',
    description: 'The page you are looking for does not exist on AALI GROUP website.',
    noindex:      true,
  };

  return <SEO {...config} />;
}

// ── App ────────────────────────────────────────────────────────────────────

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <SEOManager />
      <Header />
      <main>
        <Routes>

          {/* ── Main pages ─────────────────────────────────────────────── */}
          <Route path="/"                element={<Home />} />
          <Route path="/about"           element={<About />} />
          <Route path="/businesses"      element={<Businesses />} />
          <Route path="/investors"       element={<Investors />} />
          <Route path="/newsroom"        element={<Newsroom />} />
          <Route path="/careers"         element={<Careers />} />
          <Route path="/contact"         element={<Contact />} />
          <Route path="/founder"         element={<Founder />} />
          <Route path="/global-locations" element={<GlobalLocations />} />

         

          {/* ── Industries – canonical clean URLs ──────────────────────── */}
          <Route path="/industries/tech-cons"           element={<IndustriesTechCons />} />
          <Route path="/industries/builders-dev"        element={<IndustriesBuilders />} />
          <Route path="/industries/media-entertainment" element={<IndustriesMedia />} />
          <Route path="/industries/luxury-retail"       element={<IndustriesLuxury />} />
          <Route path="/industries/social-impact"       element={<IndustriesSocial />} />

          {/* ── Companies ──────────────────────────────────────────────── */}
          <Route path="/companies/aalitech"         element={<Aalitech />} />
          <Route path="/companies/aaliconssultancy" element={<AaliConssultancy />} />
          <Route path="/companies/aalibuilders"     element={<AaliBuilders />} />
          <Route path="/companies/aalimovies"       element={<AaliMovies />} />
          <Route path="/companies/aalifilmz"        element={<AaliFilmz />} />
          <Route path="/companies/aalimusic"        element={<AaliMusic />} />
          <Route path="/companies/aaligoldjewelz"   element={<AaliGoldJewelz />} />
          <Route path="/companies/aalitrustz"       element={<AaliTrustz />} />

          {/* ── Utility ────────────────────────────────────────────────── */}
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="*"            element={<NotFound />} />

        </Routes>
      </main>
      <Footer />
      <ChatPanel />
    </HelmetProvider>
  );
}

export default App;